import { BaseQueryApi, createApi, QueryReturnValue } from "@reduxjs/toolkit/query/react";
import { AxiosRequestHeaders } from "axios";
import { generateId } from "mermaid/dist/utils";

export const ServiceAPI = createApi({
  reducerPath: "ServiceAPI",
  endpoints: (build) => ({
    generateJd: build.mutation<any, any>({
      query: (data: any) => ({
        url: `/eximius/api/v2/enhancegeneratejd`,
        method: "post",
        data: data,
      }),
    }),

    getRecentMatches: build.mutation<any, { job_id: string; candidate_search?: boolean; }>({
      query: (data: any) => ({
        url: `/eximius/api/v2/recent_matches`,
        method: "post",
        data: data,
      }),
    }),
  }),
  baseQuery: function (args: any, api: BaseQueryApi, extraOptions: {}): QueryReturnValue<unknown, unknown, {}> | PromiseLike<QueryReturnValue<unknown, unknown, {}>> {
    throw new Error("Function not implemented.");
  }
});

export const {
  useGenerateJdMutation,
  useGetRecentMatchesMutation,
} = ServiceAPI;
export const ServiceAPIReducer = ServiceAPI.reducer;
